import React, { useState } from "react";
import "./pending.css";
import logo from "../../../assets/images/logo.png";
import alert from "../../../assets/images/alert.png";
import { useLocation, Navigate } from "react-router-dom";
import Modal from "./modal";

function Pending({ token }) {
  const location = useLocation();
  const [modalActive, setModalActive] = useState(false);
  const [email, setEmail] = useState(location.state?.booking?.email);
  
  if (
    !location.state?.booking?.change_token
  ) {
    return <Navigate to="/" replace />;
  }

  const change_token = location.state?.booking?.change_token;
  
  return (
    <div className="pending-page">
      {/* NAVBAR ================================================================= */}
      <div className="pending-nav">
        <div className="pending-logo">
          <img className="pending-logo-img" src={logo} alt="Hymus Sports" />
        </div>
      </div>

      <div className="pending-container">
        <Modal active={modalActive} setActive={setModalActive} change_token={change_token} token={token} setEmail={setEmail} />
        <img
          className="pending-img"
          src={alert}
          alt="Email Verification Required"
        />
        <h2 className="pending-title">New Athlete Verification Required!</h2>
        <p className="pending-txt">
          To finalize your booking, please verify your email: <strong>{email || 'Email Not Valid'}</strong>.
          Your booking will stay reserved for 15
          minutes from when it was created. After verification, future bookings
          will be instant!
          <br />
          <br />
          Thank you!
        </p>
        <div className="pending-btns">
          <a className="pending-btn" href="/">RETURN HOME</a>
          <button className="pending-btn" type="button" onClick={() => setModalActive(true)}>CHANGE EMAIL</button>
        </div>
      </div>
    </div>
  );
}

export default Pending;
